export default function EFGrid() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
            <path
                d="M14.0496 19.1667L19.1654 5H20.832L26.2487 19.1667L26.5816 20.0373L26.8614 20.7692L31.6654 35H30.832L19.9696 26.3115L9.16536 35H8.33203L13.3745 21.0364L13.6803 20.1894L14.0496 19.1667Z"
                fill="white"
            />
            <rect x="8.88867" y="11.1123" width="22.2222" height="2.22222" fill="white" />
            <rect x="6.66406" y="16.666" width="26.6667" height="2.22222" fill="white" />
        </svg>
    );
}
